import React from 'react';

import { Cards, CountryPicker, Chart } from './components';
import { fetchData } from './api/';
import styles from './App.module.css';

import './backgroundAnimation.css';
// import image from './images/image.png';
import image from './images/coronavirus_logo.jpg';

class App extends React.Component {
  state = {
    data: {},
    country: '',
  }

  async componentDidMount() {
    const data = await fetchData();

    this.setState({ data });
  }

  handleCountryChange = async (country) => {
    const data = await fetchData(country);

    this.setState({ data, country: country });
  }

  render() {
    const { data, country } = this.state;

    return (
        <div className={styles.container}>
          <div className='box'>
            <div className='wave -one'></div>
          {/* <div class='wave -two'></div>  */}
            <div className='wave -three'></div>
          </div>
          <img className={styles.image} src={image} alt="COVID-19" />
          <CountryPicker handleCountryChange={this.handleCountryChange} />
          <Cards data={data} />
          <Chart data={data} country={country} /> 
        </div>
    );
  }
}

export default App;